export default "__VITE_ASSET__VcCRRMxP__"